import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    activeTab: 'infos',
    creatingTag: false,
    deletedAudienceId: null,
    deletedVolumeAlertId: null,
    deletedTransfer: {
        transferId: null,
        audienceId: null
    },
    displayModal: {
        audience: false,
        transfer: false,
        volumeAlert: false,
        bulkEdit: false
    },
    expandedRows: [],
    filteredData: null,
    isAudienceCcloneTargeted: false,
    isLoading: {
        breakdown: false,
        summary: false,
        volumes: false,
        volumesChart: false
    },
    lastUuRequestKey: {
        volumes: null,
        summary: null,
        breakdown: null
    },
    selectedAudienceHaveDeletedCriteria: false,
    selectedTagLabel: null,
    selectedRowId: null,
    selectedRowFrom: null,
    formulaVolumes: {},
    typeVolume: '',
    deletedSharedAccount: {
        id: null,
        label: null
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
